module.exports = __webpack_public_path__ + "img/polygon_small.7f2fbb33.svg";